import { ModalContext } from "app/app";
import { Icon } from "components/lib";
import { Fragment, useContext } from "react";
import styles from "./styles.module.scss";

export function ExpiredDocument() {
  const { modal, setModal } = useContext(ModalContext);

  return (
    <Fragment>
      {modal.name === "expired_document" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.image}>
              <Icon image="file-text" size={40} color="#fcba03" />
            </div>
            <div className={styles.title}>{modal.data.title}</div>
            <div className={styles.description} style={{ marginTop: 15 }}>
              Our records indicate that your agency’s {modal.data.documentLabel}{" "}
              has expired or we do not have a valid {modal.data.documentLabel}{" "}
              on file.
            </div>
            <div
              className={styles.description}
              style={{ marginTop: 15, marginBottom: 15 }}
            >
              In order to continue with this quote, please use the link below to
              update your agency’s {modal.data.documentLabel}.
            </div>
            <div className={styles.footer}>
              <div className={styles.buttons}>
                <button className={styles.close} onClick={() => setModal("")}>
                  Close
                </button>
                <button
                  className={styles.update}
                  onClick={() => {
                    window.open(
                      `/app/onboarding?update=${modal.data.documentSlug}`
                    );
                  }}
                >
                  Update {modal.data.documentLabel}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
